
export default {
  computed: {
    formData () {
      return this.$store.state.flightsSearchFormData || {}
    },
    subtitle () {
      const origin = this.formData.originCity || this.formData.originText
      const destination = this.formData.destinationCity || this.formData.destinationText

      if (origin && destination && this.$te('flights.hero.subtitleFromTo')) {
        return this.$t('flights.hero.subtitleFromTo', { origin, destination })
      }
      if (destination && this.$te('flights.hero.subtitleTo')) {
        return this.$t('flights.hero.subtitleTo', { destination })
      }
      if (origin && this.$te('flights.hero.subtitleFrom')) {
        return this.$t('flights.hero.subtitleFrom', { origin })
      }
      return this.$t('flights.hero.subtitle')
    }
  }
}
